import React from 'react'

const IconEmbed = ({ width = '24', height = '24' }) => (
  <svg
    width={`${width}px`}
    height={`${height}px`}
    viewBox={`0 0 ${width} ${height}`}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        fill="currentColor"
        d="M13.3634456,3 L15.2952972,3.51763809 L10.6365544,20.904303 L8.70470277,20.3866649 L13.3634456,3 Z M17.6342136,5.59215148 L23.9981746,11.956365 L17.6342136,18.3203261 L16.22,16.9061125 L21.169,11.956 L16.22,7.00636504 L17.6342136,5.59215148 Z M6.36396103,5.58570487 L7.77817459,6.99991843 L2.828,11.949 L7.77817459,16.8994134 L6.36396103,18.3136269 L-2.66453526e-15,11.9496659 L1.41421356,10.5354523 L6.36396103,5.58570487 Z"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default IconEmbed
